import React from "react";
import { ApolloProvider } from "react-apollo";
import Notifications from "./components/Notifications";
import { NotificationsProvider } from "./NotificationsContext";
import { ErrorBoundary } from "@utils";
import { Settings, apolloClient } from "@services";

export default (props) => {
  Settings.setDefaultsFromProps(props);

  const client = apolloClient(Settings.apiUrl, {
    cacheKey: `apollo-notifications-cache-${props.currentUser.id}`,
  });

  return (
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <NotificationsProvider>
          <Notifications />
        </NotificationsProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
};
